import type { Photographer } from '@/types/photographer';

export const buildGalleryBaseUrl = (photographer?: Photographer | null): string | null => {
  const customDomain = photographer?.domainConfig?.customDomain?.trim();
  if (customDomain) {
    return `https://${customDomain}`;
  }

  const subdomain = photographer?.domainConfig?.subdomain?.trim();
  if (!subdomain) {
    return null;
  }

  return `https://pixel-share.com/${subdomain}`;
};

export const buildEventGalleryUrl = (
  photographer: Photographer | null | undefined,
  eventId: string
): string | null => {
  const baseUrl = buildGalleryBaseUrl(photographer);
  return baseUrl ? `${baseUrl}/events/${eventId}` : null;
};
